/**
 * Типы авторизации.
 *
 * Базовая модель адаптирована из 008-colver.front.bc-main/src/shared/api/auth/types.ts.
 * `CurrentUser` повторяет контракт backend colver (`POST /api/user/v1/auth/login`,
 * `GET /api/user/v1/auth/me`): собственные учётки бизнес-домена, доступы — действиями
 * (см. `@api/workspaces` → MyAccess), без ролей.
 */

/**
 * Демо-режим отображения дашборда (dev-свитчер в ProfileMenu).
 * НЕ роль доступа: backend ролей не имеет, доступы — действиями (MyAccess).
 */
export type UserRole = 'rop' | 'manager' | 'client';

/** Логиннутый пользователь. Заполняется из `/api/user/v1/auth/me`. */
export interface CurrentUser {
  sid: string;
  email: string;
  displayName?: string | null;
  /** Оператор платформы: полный доступ + операторская консоль. */
  isOperator: boolean;
  state: string;
  /** Показанные ознакомительные туры (`TourKey`): сами больше не открываются. */
  seenTours?: string[];
}

/** Ознакомительные туры разделов (ключи бэка `UiTour`). */
export type TourKey = 'user-metrics' | 'clients';

/** Запрос на вход. */
export interface LoginRequest {
  email: string;
  password: string;
}

// ─── Gatekeeper auth (наследие 008, фронт пока использует только парсер) ───

export enum AuthEntityTypes {
  sudo = 2 ** 0,
  admin = 2 ** 1,
  client = 2 ** 2,
  token = 2 ** 3,
  user = 2 ** 4,
  nothing = 2 ** 5,
}

export interface AuthSid {
  entityType: AuthEntityTypes;
  entitySid: string;
  userSid?: string;
}

/**
 * Context авторизации. `currentUser` — для UI (имя/компания в Topbar),
 * `authSid` — синтетическая обёртка для legacy-кода, ждущего AuthSid.
 */
export interface AuthContextType {
  isLoading: boolean;
  isAuthenticated: boolean;
  currentUser?: CurrentUser;
  authSid?: AuthSid;
  error: unknown;
  /** Очистить сессию и редиректнуть на /login. */
  logout: () => void;
}
